<template>
  <page-outline :title="`${nextDueDate} - ${$t('mandate.total')} : ${listItemsPaymentSchedule.length > 0 ? formatCurrency(listItemsPaymentSchedule[0].Total) : formatCurrency(0)}`">
    <template slot="pageContent">
      <b-container fluid>
        <b-row class="mt-3 align-items-center">
          <b-col cols="auto">
            <back-button class="btnFilter_2 mr-2 btn-back" :returnUrl="returnUrl"></back-button>
          </b-col>
        </b-row>

        <hr class="mx-auto" />
        <!-- Contenu principal -->
        <b-row>
          <b-col cols="12" class="mx-auto mb-4">
            <div style="overflow:auto">
              <spinner v-if="activateSpinner"></spinner>
              <b-table v-else-if="listItemsPaymentSchedule.length > 0"
                striped
                hover
                responsive
                :items="listItemsPaymentSchedule"
                :fields="fields"
                class="table table-striped"
                style="margin-bottom:0"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDir"
                @head-clicked="sortTable"
                :key="refreshKey"
                :empty-text="$t('common.security.no_result')"
                @row-clicked="onRowClicked">
                <template #cell(amount)="data">
                  {{ formatCurrency(data.item.amount) }}
                </template>
                <!-- <template #cell(periodicity)="data">
                  <span v-if="data.value !== ''"> {{ data.value }} </span>
                  <span v-else>-</span>
                </template> -->
                <template #cell(frequency)="data">
                  <span v-if="data.value !== ''">{{ $t('mandate.frequency_type_' + data.value) }}</span>
                  <span v-else>-</span>
                </template>
                <template #cell(nextDueDate)="data">
                  <span v-if="data.value !== ''"> {{ formatDate(data.item.nextDueDate) }} </span>
                  <span v-else>-</span>
                </template>
                <template #cell(status)="data">
                  <span v-if="data.value !== ''" :class="['chip','chip--' + statusVariant(data)]">{{ $t('mandate.status_payment_schedule_' + data.value) }}</span>
                  <span v-else>-</span>
                </template>
                <template #cell(StatusCollection)="data">
                  <span v-if="data.value !== ''" :class="['chip','chip--' + statusVariantCollection(data)]">{{ $t('mandate.status_collection_' + data.value) }}</span>
                  <span v-else :class="['chip','chip--' + statusVariantCollection(data)]">{{ $t('mandate.status_collection_not_created') }}</span>
                </template>
                <template #cell(actions)="{ item }">
                  <b-link @click.stop.prevent="onRowClicked(item)" class="text-decoration-none">
                    {{ $t('mandate.view_details') }}
                  </b-link>
                </template>
              </b-table>
              <div v-else class="d-flex justify-content-center">
                <span class="noResult">
                  {{ $t('common.no_result') }}
                </span>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-5">
          <b-col>
            <cm-pagination
              :maxResultsByPage="paginationObject.maxResults"
              :firstIndex="paginationObject.firstIndex"
              :nbResultsTotal="paginationObject.nbResultsTotal"
              :refreshEvent="paginationObject.refresh">
            </cm-pagination>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </page-outline>
</template>

<script>
import PageOutline from '@/components/common/PageOutline.vue'
import { reloadPage2, loadPage } from '@/helpers/routing'
import { paymentSchedules, frequencies, formatDate } from '@/data/mockData'
import dateTimePicker from '@/components/common/dateTimePicker.vue'
import moment from 'moment-timezone'
import { errorMessageAlert } from "@/helpers/alert"
import Spinner from "@/components/common/spinner.vue"
import Pagination from '@/components/common/pagination.vue'
import BackButton from '@/components/common/backButton.vue'

export default {
  name: 'PaymentScheduleList',
  components: {
    'page-outline': PageOutline,
    'datetime-picker-custom': dateTimePicker,
    spinner: Spinner,
    'cm-pagination': Pagination,
    BackButton
  },
  data() {
    return {
      activateSpinner: false,
      currentYear: new Date().getFullYear(),
      filterConditions: {},
      listItemsPaymentSchedule: [],
      nextDueDate: '',
      fields: [
        { key: 'UMR', label: this.$t('mandate.unique_mandate_rf'), sortable: true, class: 'text-center' },
        { key: 'debtor', label: this.$t('mandate.dbtr'), sortable: true, class: 'text-center' },
        { key: 'amount', label: this.$t('mandate.amt'), sortable: true, class: 'text-center' },
        { key: 'frequency', label: this.$t('mandate.frequency_type'), sortable: true, class: 'text-center' },
        // { key: 'periodicity', label: this.$t('mandate.periodicity'), sortable: true, class: 'text-center' },
        // { key: 'nextDueDate', label: this.$t('mandate.date_due_next'), sortable: true, class: 'text-center' },
        { key: 'status', label: this.$t('mandate.status_collection'), sortable: true, class: 'text-center status-col' },
        { key: 'StatusCollection', label: this.$t('mandate.status_collection_d'), sortable: true, class: 'text-center status-col' },
        { key: 'actions', label: this.$t('mandate.actions'), class: 'text-center' }
      ],
      pageCounter: 0,
      paginationObject: {},
      sortBy: '',
      sortDir: false,
      timezone: '+00:00'
    }
  },
  created() {
    this.timezone = moment.tz.guess()
    this.nextDueDate = this.$route.query.nextDueDate
    this.HistoryDate = this.$route.query.HistoryDate
    this.currentYearNav = this.$route.query.currentYear
    this.IdPaymentScheduleBulk = this.$route.query.IdPaymentScheduleBulk
    if (this.IdPaymentScheduleBulk !== undefined) {
      this.returnUrl = '/payment-schedules/bulk/details/' + this.IdPaymentScheduleBulk + '?IdPaymentScheduleBulk=' + this.IdPaymentScheduleBulk
    } else {
      this.returnUrl = '/payment-schedules/unit'
    }

    if (this.filterConditions) {
      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }
    }
    // this.activateSpinner = true

    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 15
    this.paginationObject['nbResultsTotal'] = 0
    let that = this
    this.$bus.$off('refresh-cache-contacts')

    this.paginationObject['refresh'] = 'direct-inbox-filtered'
    this.$bus.$off('direct-inbox-filtered')
    this.$bus.$on('direct-inbox-filtered', index => {
      this.getPaymentSchedule(index)
      that.pageCounter = 0
    })

    this.pageCounter = 0
    this.onRefresh()
  },
  methods: {
    applyFilter(filterConditions = {}) {
      this.filterConditions = filterConditions

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0

      this.activateSpinner = true

      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }

      this.getPaymentSchedule()
    },
    formatCurrency (n) {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'EUR', maximumFractionDigits: 2 }).format(n)
    },
    formatDate(dateIso) {
      return dateIso.replace("T", " ")
    },
    getPaymentSchedule(index = 1) {
      this.pageCounter = 0
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0
      let that = this
      let params = {
        UMR: '',
        nextDueDate: this.nextDueDate,
        maxResults: this.paginationObject.maxResults,
        firstIndex: this.paginationObject.firstIndex,
        CurrentYear: this.currentYearNav,
        HistoryDate: this.HistoryDate,
        IdPaymentScheduleBulk: this.IdPaymentScheduleBulk || ''
      }
      if (this.filterConditions.OrderByField) {
        params.OrderByField = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        params.OrderByDirection = this.filterConditions.OrderByDirection
      }
      this.$engine.paymentSchedule.getPaymentSchedule(params).then((resp) => {
        that.paginationObject.nbResultsTotal = resp.data.nbTotalResultsCalendar
        that.paginationObject.nbResults = resp.data.PaymentScheduleCalendar.length

        let PaymentScheduleList = {}

        PaymentScheduleList = resp.data.PaymentScheduleCalendar
        PaymentScheduleList.forEach(item => {
          if (['0'].includes(String(item.status))) {
            item.nextDueDate = '-'
          }
        })

        that.updatePaymentSchedule(PaymentScheduleList)

        this.$f7.pullToRefreshDone()
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    onRefresh() {
      this.refreshKey = !this.refreshKey
      this.activateSpinner = true
      this.getPaymentSchedule()
    },
    onRowClicked(item) {
      if (item && item.id) {
        if (this.IdPaymentScheduleBulk !== undefined) {
          loadPage(this, { url: '/payment-schedules/unit/details/' + item.id + '?IdPaymentScheduleBulk=' + this.IdPaymentScheduleBulk + "&nextDueDate=" + this.nextDueDate + "&currentYear=" + this.currentYear })
        } else {
          loadPage(this, { url: '/payment-schedules/unit/details/' + item.id + "?nextDueDate=" + this.nextDueDate + "&currentYear=" + this.currentYear })
        }
      }
    },
    refreshList () {
      this.page = 1
      this.transactions = this.transactions.slice()
      this.applyFilter()
    },
    sortTable (key, field, event, isFooter) {
      const sortableFields = [
        'UMR',
        'debtor',
        'amount',
        'frequency',
        'nextDueDate',
        'status',
        'StatusCollection'
      ]

      if (!sortableFields.includes(key)) {
        return
      }

      let sortDirection = 'ASC'
      if (key === this.sortBy && this.sortDir === false) {
        sortDirection = 'DESC'
      }

      this.filterConditions.OrderByField = key
      this.filterConditions.OrderByDirection = sortDirection
      this.applyFilter(this.filterConditions, this.paginationObject.firstIndex)
    },
    statusVariant(status) {
      const variants = {
        0: 'secondary',
        1: 'success'
      }
      return variants[status.value] || 'secondary'
    },
    statusVariantCollection(status) {
      const variants = {
        1: 'warning',
        2: 'success',
        3: 'danger',
        4: 'secondary',
        5: 'info',
        6: 'danger',
        7: 'success',
        8: 'warning',
        9: 'secondary',
        10: 'info'
      }
      return variants[status.value] || 'secondary'
    },
    updatePaymentSchedule(PaymentScheduleList) {
      this.listItemsPaymentSchedule = PaymentScheduleList
    }
  }
}
</script>

<style scoped>
.status-col { width: 180px; }
.chip{
  --chip-border:#9ca3af; --chip-bg:rgba(156,163,175,.12); --chip-fg:#374151;
  display:inline-flex; align-items:center; justify-content:center;
  height:28px; min-width:150px; padding:0 .75rem; border-radius:999px;
  font-size:.75rem; font-weight:600; letter-spacing:.2px;
  border:1px solid var(--chip-border); background-color:var(--chip-bg); color:var(--chip-fg); white-space:nowrap;
}
.chip--success{ --chip-border:#16a34a; --chip-bg:rgba(22,163,74,.10); --chip-fg:#166534; }
.chip--warning{ --chip-border:#f59e0b; --chip-bg:rgba(245,158,11,.12); --chip-fg:#92400e; }
.chip--danger{  --chip-border:#ef4444; --chip-bg:rgba(239,68,68,.10); --chip-fg:#991b1b; }
.chip--secondary{ --chip-border:#9ca3af; --chip-bg:rgba(156,163,175,.12); --chip-fg:#374151; }
.chip--info{ --chip-border:#60a5fa; --chip-bg:rgba(96,165,250,.12); --chip-fg:#0b4a6f; }
</style>
